import { ContainerTheme } from 'src/components/container/container-theme';

export const smallContainerStyles: ContainerTheme = {
  maxWidth: '648px',
};
